@if (!consentGiven) {
  <aside #cookieBanner class="cookies-banner dark:bg-card" role="region" aria-label="Cookie consent banner">
    <div class="cookies-banner-content dark:bg-card">
      <div class="text-start">
        <p class="text-[18px] font-bold">{{"cookiesDisclaimer.consentTextLable" | translate}}<a href="https://eprintit.com/privacy-policy/"
        target="_blank">{{"cookiesDisclaimer.privacyPolicyLabel" | translate}}</a>
      </p>
      <div class="text-[14px] font-normal text-[var(--disabled)] dark:text-black">{{"cookiesDisclaimer.newNecessaryCookieTextLabel" | translate}}
      </div>
    </div>
    <button id="giveConsent" mat-raised-button color="primary"
    (click)="giveConsent()">{{"cookiesDisclaimer.necessaryCookieButtonLabel" | translate}}</button>
  </div>
</aside>
}
